<template>
  <div id="toEat">
    <div class="wheel6666">
      <div
        :class="['wheel6666-light', onRotation ? 'wheel6666-light-twinkling' : '']"
        v-for="(light, index) in foodList"
        :key="index"
      ></div>
      <div class="wheel6666-panel">
        <div class="wheel6666-panel-sector" v-for="food in foodList" :key="food">
          <div class="wheel6666-panel-sector-inner">
            <span>{{ food }}</span>
          </div>
        </div>
        <div
          class="wheel6666-panel-pointer"
          :class="[onRotation ? 'wheel6666-panel-pointer-trans' : '']"
          @transitionend="afterTransitionend"
          @click="handleClick"
        >
          开始
        </div>
      </div>
    </div>

    <div class="result">{{ result }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      foodList: [
        "自由",
        "成长",
        "开心",
        "担忧",
        "紧张",
        "愤怒",
        "自我",
        "娱乐",
        "家庭",
      ],
      onRotation: false, // 记录当前是否正在旋转，如果正在旋转，就不能继续点击了
      result: "这里是结果", //结果文案
      nextStatus: {}, //转盘的下一个状态
    };
  },
  methods: {
    afterTransitionend() {
      const { nextStatus } = this;
      setTimeout(() => {
        // 等闪烁三下结束
        this.onRotation = false; //结束旋转状态
        this.result = nextStatus.text; //更新结果文案为下一步状态的文案
      }, 300);
    },
    //获得当前结果
    getReward() {
      let getEle = document.getElementsByClassName.bind(document);
      let pointer = getEle("wheel6666-panel-pointer")[0]; //获取指针元素
      let currentDeg = this.nextStatus.deg ? this.nextStatus.deg : 0; //如果当前已有角度则获取角度 无则为0
      // 转三圈到四圈
      let rotateDeg = Math.random() * 360 + 1080;
      currentDeg += rotateDeg; //加上旋转的随机角度
      let rewardText =
        this.foodList[Math.floor(((currentDeg + 20) % 360) / 40)]; //获取结果位置的食物
      this.nextStatus = {
        deg: currentDeg,
        text: `就决定是你了！${rewardText}`,
      }; //更新下一步状态
      pointer.style.transform = `rotateZ(${this.nextStatus.deg}deg)`; //旋转+动画
    },
    //重置
    reset() {
      this.onRotation = false; //关闭旋转状态
      this.result = "   "; //结果清空
    },
    // 功能1:转动转盘
    // 1.点击中间按钮转动转盘
    // 2.获得结果并显示
    // 3.制作灯闪效果
    handleClick() {
      if (this.onRotation) return; //如果在旋转 不执行

      this.reset(); //重置
      this.onRotation = true; //开启旋转状态 禁止点击事件
      this.getReward(); //获取结果
    },
  },
};
</script>

<style scoped lang="scss">
.wheel6666 {
  position: relative;
  box-sizing: revert;
  height: 200px;
  width: 200px;
  padding: 20px;
  background-color: rgb(66, 161, 254);
  box-shadow: #000000 0px 0px 10px;
  border-radius: 50%;
  margin: 20px auto;

  &-light {
    position: absolute;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    top: 5px;
    left: 115px;
    transform-origin: 5px 115px;

    &-twinkling {
      animation: 1s twinkling 3, 100ms 3s twinkling 3;
    }

    &:nth-child(3n) {
      background-color: rgb(89, 255, 179);
    }

    &:nth-child(3n + 1) {
      background-color: rgb(255, 141, 148);
    }

    &:nth-child(3n + 2) {
      background-color: rgb(255, 209, 50);
    }

    &:nth-child(2) {
      transform: rotate(40deg);
    }

    &:nth-child(3) {
      transform: rotate(80deg);
    }

    &:nth-child(4) {
      transform: rotate(120deg);
    }

    &:nth-child(5) {
      transform: rotate(160deg);
    }

    &:nth-child(6) {
      transform: rotate(200deg);
    }

    &:nth-child(7) {
      transform: rotate(240deg);
    }

    &:nth-child(8) {
      transform: rotate(280deg);
    }

    &:nth-child(9) {
      transform: rotate(320deg);
    }
  }

  &-panel {
    position: relative;
    height: 200px;
    width: 200px;
    background-color: #b7b7b7;
    border-radius: 100px;

    &-sector {
      position: absolute;
      left: 100px;
      top: 0px;
      width: 100px;
      height: 200px;
      font-size: 14px;
      border-radius: 0px 100px 100px 0;
      overflow: hidden;
      transform-origin: left center;

      &:nth-child(1) {
        transform: rotate(-20deg);
      }

      &:nth-child(2) {
        transform: rotate(20deg);
      }

      &:nth-child(3) {
        transform: rotate(60deg);
      }

      &:nth-child(4) {
        transform: rotate(100deg);
      }

      &:nth-child(5) {
        transform: rotate(140deg);
      }

      &:nth-child(6) {
        transform: rotate(180deg);
      }

      &:nth-child(7) {
        transform: rotate(220deg);
      }

      &:nth-child(8) {
        transform: rotate(260deg);
      }

      &:nth-child(9) {
        transform: rotate(300deg);
      }

      &:nth-child(3n + 1) &-inner {
        background: rgb(255, 209, 50);
      }

      &:nth-child(3n + 2) &-inner {
        background: rgb(188, 202, 255);
      }

      &:nth-child(3n) &-inner {
        background: rgb(91, 222, 255);
      }

      &-inner {
        box-sizing: revert;

        text-align: center;
        display: block;
        width: 40px;
        padding: 5px 3px 0 57px;
        height: 195px;
        transform: translateX(-100px) rotate(40deg);
        transform-origin: right center;
        border-radius: 100px 0 0 100px;

        span {
          display: block;
          transform-origin: center;
          transform: rotate(-19deg);
          color: #d46854;

          position: relative;
          left: 0px;
          bottom: -21px;
        }
      }
    }

    &-pointer {
      box-sizing: revert;
      position: absolute;
      left: 79px;
      top: 79px;
      z-index: 10;
      height: 30px;
      width: 30px;
      padding: 6px;
      color: #fff899;
      line-height: 15px;
      font-size: 14px;
      text-align: center;
      background-color: #ff5350;
      border-radius: 50%;
      border: 1px solid #ff5350;

      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;

      &-trans {
        transition: transform 3s cubic-bezier(0.2, 0.93, 0.43, 1);
      }

      &::after {
        content: "";
        position: absolute;
        left: 14px;
        top: -24px;
        border-width: 12px 6px;
        border-style: solid;
        border-color: transparent;
        border-bottom-color: #ff5350;
        transform-origin: center;
      }
    }
  }
}


.result {
  height: 50px;
  line-height: 50px;
  text-align: center;
  /*margin: 20px 60px;*/
  margin: 0 auto;
}

@keyframes twinkling {
  50% {
    background: transparent;
  }
}
</style>
